<template>
  <div>
    <loader :loading="loading"></loader>

    <div class="container login-page">
      <div v-if="errorMessage.length" class="row justify-content-center">
        <div class="col-md-12 col-lg-8">
          <base-alert class="text-center" type="danger">{{ errorMessage }}</base-alert>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6 ml-auto mr-auto">
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(login)">
              <card class="card-login card-white">
                <template slot="header">
                  <img src="img/card-primary.png" alt="Background" />
                  <h1 class="card-title">Log in</h1>
                </template>

                <div>
                  <validation-provider rules="requiredUsername" v-slot="{ errors }">
                    <base-input
                      label="Username"
                      addon-left-icon="tim-icons icon-single-02"
                      :error="errors[0]"
                      v-model="username">
                    </base-input>
                  </validation-provider>
                </div>

                <div>
                  <validation-provider rules="requiredPassword" v-slot="{ errors }">
                    <base-input
                      label="Password"
                      type="password"
                      addon-left-icon="tim-icons icon-lock-circle"
                      :error="errors[0]"
                      v-model="password">
                    </base-input>
                  </validation-provider>
                </div>

                <div slot="footer">
                  <base-button native-type="submit" type="primary" class="mb-3" size="lg" block>
                    Login
                  </base-button>
                  <div class="pull-left">
                    <h6>
                      <router-link class="link footer-link active-link" to="/admin/forgot">
                        Forgot Password?
                      </router-link>
                    </h6>
                  </div>
                </div>
              </card>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { mapGetters, mapMutations } from 'vuex';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { BaseAlert } from 'src/components';
  import { finalizeConfirmation, getRoleLevels, getUserSurveys } from 'src/modules/adminActions';
  import { isNullOrEmpty, copyObject } from '../../modules/utils';

  export default {
    components: {
      Loader,
      ValidationObserver,
      ValidationProvider,
      BaseAlert
    },
    data() {
      return {
        username: null,
        password: null,
        errorMessage: '',
        loading: false,
        availableSurveys: [],
        userSurveys: [],
        singleSurvey: null,
      }
    },
    computed: {
      ...mapGetters({
        authCheckTime: 'authCheckTime',
        adminUser: 'adminUser',
        surveys: 'surveys',
        adminUserIsUser: 'adminUserIsUser',
        userAssignments: 'userAssignments',
      })
    },
    methods: {
      login() {
        this.errorMessage = '';
        this.loading = true;
        this.removeRedirectRoute();

        this.$store
          .dispatch('addAuthenticatedUser', {
            "username": this.username,
            "password": this.password
          })
          .then(() => {
            if(this.adminUser.roles && this.adminUser.roles.length > 0) {
              if(this.adminUser.email === null || this.adminUser.emailConfirmed === false) {
                this.redirectToCreateEmail();
              }
              else {
                getRoleLevels()
                .then(() => {
                  if (this.adminUserIsUser) {
                    if (this.userAssignments) {
                      this.userSurveys = this.userAssignments.userSurveys;
                      this.resolveAvailableSurveys("Call from this.userAssignments is available");
                      this.redirectToAdminDefault();
                    }
                    else {
                      getUserSurveys()
                        .then(response => {
                          this.userSurveys = response.data;
                          this.resolveAvailableSurveys("Call from getUserSurveys(), this.userAssignments is NOT available");
                          this.redirectToAdminDefault();
                        });
                    }
                  }
                  else {
                    this.redirectToAdminDefault();
                  }
                  this.loading = false;
                });
              }
            }
            else {
              this.loading = false;
              this.errorMessage = 'Sorry. The system is denying access. Please contact your site adminstrator.'
            }
          })
          .catch((error) => {
            this.loading = false;

            if(error.response) {
              if(error.response.status === 401) {
                this.errorMessage = 'The username or password is incorrect.';
              }
              else {
                this.errorMessage = 'Sorry - something went wrong. Please try again later.'
              }
            }
          });
      },
      redirectToAdminDefault() {
        let path;
        let routeTo;

        if (this.adminUser.passwordChangeRequired === true) {
          path = '/admin/password';
          this.addRedirectRoute(path);
          routeTo = { path: path };
        }
        else {
          path = '/admin/surveys';
          routeTo = { path: path };
          if (this.adminUserIsUser) {
            let routename = "Surveys";
            let routeParams = {};
            if (this.singleSurvey) {
              if (this.singleSurvey.orgSurveys.length === 1) {
                const instance = this.singleSurvey.orgSurveys[0];
                routename = "InstanceDashboard";
                routeParams = { 
                  surveyId: instance.hspSurveyId, 
                  urlId: instance.surveyUrlId,
                  routeFrom: "login",
                };
              }
              else {
                routename = "Instances";
                routeParams = { 
                  surveyId: this.singleSurvey.hspSurveyId, 
                  surveyInfo: JSON.stringify(this.singleSurvey), 
                  routeFrom: "login",
                };
              }
            }
            else {
              routeParams = { 
                res: {userSurveys: JSON.stringify(this.userSurveys), availableSurveys: JSON.stringify(this.availableSurveys)}, 
                routeFrom: "login",
              };
            }

            // Use the 'name' form of the route so we can pass in the 'params' property
            routeTo = { 
              name: routename, 
              params: routeParams
            };
          }
        }

        this.$router.push(routeTo)
        .catch(() => {
          this.loading = false;
          this.errorMessage = 'Unauthorized access. Please contact your administrator.';
        });
      },
      redirectToCreateEmail() {
        if(this.$route.query.token) {
          finalizeConfirmation({
            "username": this.username,
            "email": this.$route.query.email,
            "token": this.$route.query.token
          }).then(() => {
            this.redirectToAdminDefault();
          });
        }
        else {
          let path = '/admin/email';
          this.addRedirectRoute(path);
          this.$router.push({ path: path });
        }
      },
      filterSurveys(surveys) {
        let filteredSurveys = [];

        surveys.forEach(x => {
          let survey = copyObject(x);
          if (this.userSurveys) {
            survey.orgSurveys = survey.orgSurveys.filter(x => 
              this.userSurveys.findIndex(y => y.hspSurveyId === x.hspSurveyId || y.orgSurveyId === x.orgSurveyId) > -1
            );
          }

          survey.orgSurveys.forEach(orgSurvey => {
            orgSurvey.reviewUrl = `${process.env.VUE_APP_URL}/surveys/access/${orgSurvey.hspSurveyId}/${orgSurvey.surveyUrlId}/review`;
            orgSurvey.surveyUrl = `${process.env.VUE_APP_URL}/surveys/${orgSurvey.surveyUrlId}`;
          });

          filteredSurveys.push(survey);
        });

        return filteredSurveys;
      },
      resolveAvailableSurveys(msg) {
        if (isNullOrEmpty(this.userSurveys)) {
          return;
        }

        this.availableSurveys = this.surveys.filter(surv =>
            this.userSurveys.findIndex(usr => 
              usr.hspSurveyId === surv.hspSurveyId ||
              surv.orgSurveys.findIndex(org => org.orgSurveyId === usr.orgSurveyId) > -1
            ) > -1
        );

        const surveys = this.filterSurveys(this.availableSurveys);
        if (surveys.length === 1) {
          this.singleSurvey = surveys[0];
        }
        this.availableSurveys = surveys;
      },
      ...mapMutations([
        'addRedirectRoute',
        'removeRedirectRoute'
      ])
    }
  };
</script>
<style>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
